export default "__VITE_ASSET__IVshwt0S__"